<template lang="pug">
.v-not-found-page.not-found-page(v-if="data")
	h1.not-found-page__title(v-if="data.title" ) {{ data.title }}
	.not-found-page__items(v-if="data.items" )
		.not-found-page__item(
				v-for="(item, index) in data.items"
				:key="index"
				:style="{background: item.background ? `center / cover no-repeat url(${item.background})` : `#0E0E0F`}")
			| {{ item.text }}
	.not-found-page__text(v-if="data.text" v-html="data.text" )
	.not-found-page__links(v-if="data.links")
		a.not-found-page__link.btn.btn-gap(
				v-for="(link, index) in data.links"
				:href="link?.href"
				:key="index"
				:class="link.className")
			| {{ link.text }}
			.btn-arrow.btn__icon
				.btn-arrow__track
					.btn-arrow__track-item
						v-scope
							v-svg-icon.icon-arrow(icon="btn-arrow")
					.btn-arrow__track-item
						v-scope
							v-svg-icon.icon-arrow(icon="btn-arrow")
	.not-found-page__category
		.not-found-page__title(v-if="data.subtitle" ) {{ data.subtitle }}
		.not-found-page__cards(v-if="data.cards" )
			v-section-top-card.not-found-page__card(v-for="(card, index) in data.cards" :key="index" :data-source="card")


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>